import { FC, useState } from 'react';

import { CompareRule, RequiredRule } from 'devextreme-react/cjs/form';

import { AppFieldBox } from 'components/appComponents';
import { TextBox, Validator } from 'devextreme-react';
import { AccountResetPassword } from 'pages/Accounts/Accounts.entity';

type Props = {
  form: AccountResetPassword;
  onChange: (name: keyof AccountResetPassword, value: AccountResetPassword[keyof AccountResetPassword]) => void;
};

export const ChangePasswordForm: FC<Props> = ({ form, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div>
      <AppFieldBox label="Новый пароль" labelTop>
        <TextBox
          stylingMode="underlined"
          placeholder="Введите пароль"
          value={form.password}
          onValueChange={(e) => onChange('password', e)}
          mode={showPassword ? 'text' : 'password'}
          buttons={[
            {
              name: 'togglePassword',
              location: 'after',
              options: {
                //stylingMode: 'text',
                icon: showPassword ? 'eyeclose' : 'eyeopen',
                onClick: () => setShowPassword((prev) => !prev),
              },
            },
          ]}
        >
          <Validator>
            <RequiredRule message="Заполните поле Пароль" />
          </Validator>
        </TextBox>
      </AppFieldBox>
      <AppFieldBox label="Подтвердите пароль" labelTop>
        <TextBox
          value={form.confirmPassword}
          onValueChange={(e) => onChange('confirmPassword', e)}
          stylingMode="underlined"
          placeholder="Подтвердите пароль"
          mode={showConfirmPassword ? 'text' : 'password'}
          buttons={[
            {
              name: 'toggleConfirmPassword',
              location: 'after',
              options: {
                //stylingMode: 'text',
                icon: showConfirmPassword ? 'eyeclose' : 'eyeopen',
                onClick: () => setShowConfirmPassword((prev) => !prev),
              },
            },
          ]}
        >
          <Validator>
            <RequiredRule message="Подтверждение пароля обязательно" />
            <CompareRule comparisonTarget={() => form.password} message="Пароли должны совпадать" />
          </Validator>
        </TextBox>
      </AppFieldBox>
    </div>
  );
};
